import { Close } from '@mui/icons-material';
import {
  Breakpoint,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

export interface SaveFormProps {
  title: string;
  isOpen?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  update_at?: string;
  maxWidth?: Breakpoint;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
}

function SaveForm(props: SaveFormProps) {
  const { zIndex, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const {
    title,
    isOpen = false,
    maxWidth = 'xl',
    children,
    update_at,
    onClose,
    onSubmit,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      scroll={isMobile ? 'body' : 'paper'}
    >
      <form onSubmit={onSubmit}>
        <DialogTitle
          display="flex"
          alignItems="center"
          position="sticky"
          sx={{
            top: 0,
            zIndex: zIndex.modal,
            background: '#fff',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
          }}
        >
          <IconButton size="small" onClick={onClose} sx={{ mr: 1.5 }}>
            <Close />
          </IconButton>

          {title}

          <Typography variant="caption" color="gray" sx={{ ml: 'auto', mr: 2 }}>
            {update_at && `Recent Save Time: ${update_at}`}
          </Typography>

          <Button
            size="small"
            type="submit"
            variant="contained"
            sx={{ display: onSubmit ? 'block' : 'none' }}
          >
            保存
          </Button>
        </DialogTitle>

        <DialogContent>{children}</DialogContent>
      </form>
    </Dialog>
  );
}

export default SaveForm;
